import { Component } from '@angular/core';
import { NotificationService } from '../services/notification.service';
import { Notification } from '../models/Notification';
import { environment } from '../../environments/environment';
import { BroadcastService } from '../services/broadcast.service';
import { ManagerService } from '../services/manager.service';
import { Manager } from '../models/Manager';

@Component({
  selector: 'notifications',
  templateUrl: 'notifications.component.html',
  styleUrls: ['notifications.component.css']
})
export class NotificationsComponent {

  manager!: Manager;
  notification!: Notification;
  intervalId!: any;

  constructor(private managerService: ManagerService, private notificationService: NotificationService, private broadcastService: BroadcastService)
  {
    this.broadcastService.subscribe(message => {
      if (message.type == this.broadcastService.REFRESH_NOTIFICATIONS)
        this.loadNotifications();
    });
  }

  ngOnInit() {
    this.manager = this.managerService.getLoggedUser();

    this.loadNotifications();
    this.startCheck();
  }

  loadNotifications() {
    this.notificationService.get().subscribe(
      result => { this.notification = result as Notification; }
    );
  }

  startCheck() {
    this.intervalId = setInterval(() => this.loadNotifications(), environment.notificationsCheckInterval * 1000);
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }
}
